// client/src/components/crowdfunding/ApplicationForm.tsx

import React, { useState } from "react";
import { createApplication } from "../../services/crowdfundingService";
import "../../assets/styles/crowdfunding.css";

const ApplicationForm: React.FC = () => {
  const [fullName, setFullName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [school, setSchool] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Basic validation
    if (!fullName || !email || !school) {
      setError("All fields are required.");
      return;
    }
    setError(null);
    setLoading(true);

    // Update your payload to include the missing properties.
    const payload = {
      applicantId: "dummy-applicant-id",  // Replace with dynamic data (e.g., current user's id)
      fullName,
      email,
      school,
      criteria: {}                        // For now, an empty object; update as needed
    };

    try {
      const response = await createApplication(payload);
      console.log("Application submitted successfully:", response);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || "Failed to submit application.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="application-form">
      <h2>Crowdfunding Application</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success ? (
        <p style={{ color: "green" }}>Application submitted successfully!</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div>
            <label>Full Name:</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Enter your full name"
              required
            />
          </div>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div>
            <label>School:</label>
            <input
              type="text"
              value={school}
              onChange={(e) => setSchool(e.target.value)}
              placeholder="Enter your school name"
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Application"}
          </button>
        </form>
      )}
    </div>
  );
};

export default ApplicationForm;
